// Reports Vietnamese translations
export const reportsVi = {
  'actual.route': 'Tuyến Đường Thực Tế',
  'actual.route.gps': 'Tuyến Đường Thực Tế (GPS)',
  'actual.route.tolls': 'Phí Cầu Đường Tuyến Thực Tế',
  'analyzing': 'Đang phân tích',
  'avg.speed.limit': 'Giới Hạn Tốc Độ TB',
  'click.record.to.view.analysis': 'Nhấp vào bản ghi từ danh sách để xem phân tích tuyến đường và chi phí',
  'click.to.analyze': 'Nhấp để phân tích',
  'cost.analysis': 'Phân Tích Chi Phí',
  'cost.comparison': 'So Sánh Chi Phí',
  'currently.analyzing': 'Đang Phân Tích',
  'daily.financial.report': 'Báo Cáo Tài Chính Hàng Ngày',
  'daily.profit.chart': 'Biểu Đồ Lợi Nhuận Hàng Ngày',
  'difference': 'Chênh Lệch',
  'distance.difference': 'Chênh Lệch Quãng Đường',
  'duration': 'Thời Lượng',
  'efficient.route.taken': 'Đã Chọn Tuyến Đường Hiệu Quả',
  'enable.route.display': 'Bật Hiển Thị Tuyến Đường',
  'export.route.points': 'Xuất Điểm Tuyến Đường (JSON)',
  'fee.comparison': 'So Sánh Phí',
  'filtered.points': 'Điểm Đã Lọc',
  'fuel.cost': 'Chi Phí Nhiên Liệu',
  'fuel.savings': 'Tiết Kiệm Nhiên Liệu',
  'loading.addresses': 'Đang tải 3 địa chỉ cùng lúc',
  'loading.shipping.records': 'Đang tải bản ghi vận chuyển...',
  'max.speed.limit': 'Giới Hạn Tốc Độ Tối Đa',
  'monthly.financial.report': 'Báo Cáo Tài Chính Hàng Tháng',
  'no.shipping.records.found': 'Không Tìm Thấy Bản Ghi Vận Chuyển',
  'no.toll.fees.detected': 'Không Phát Hiện Phí Cầu Đường',
  'no.toll.on.visible.routes': 'Không tìm thấy điểm thu phí trên các tuyến đường hiển thị',
  'optimal.route': 'Tuyến Đường Tối Ưu',
  'optimal.route.osrm': 'Tuyến Đường Tối Ưu (OSRM)',
  'optimal.route.tolls': 'Phí Cầu Đường Tuyến Tối Ưu',
  'potential.savings.identified': 'Đã Xác Định Tiết Kiệm Tiềm Năng',
  'profit': 'Lợi Nhuận',
  'route.points': 'Điểm Tuyến Đường',
  'route.statistics': 'Thống Kê Tuyến Đường',
  'route.visualization': 'Trực Quan Hóa Tuyến Đường',
  'select.shipping.record.to.analyze': 'Chọn bản ghi vận chuyển để phân tích',
  'shipping.cost.analysis': 'Phân Tích Chi Phí Vận Chuyển',
  'shipping.records': 'Bản Ghi Vận Chuyển',
  'showing.points.30min.apart': 'Hiển thị các điểm cách nhau ≥30 phút',
  'toggle.route.visibility': 'Bật/tắt hiển thị tuyến đường để xem vị trí trạm thu phí',
  'toll.fee': 'Phí Cầu Đường',
  'toll.fee.locations': 'Vị Trí Trạm Thu Phí',
  'total.actual.fees': 'Tổng Phí Tuyến Thực Tế:',
  'total.cost': 'Tổng Chi Phí',
  'total.optimal.fees': 'Tổng Phí Tuyến Tối Ưu:',
  'total.points': 'Tổng Điểm',
  'total.savings': 'Tổng Tiết Kiệm',
  'try.adjusting.filters': 'Thử điều chỉnh bộ lọc ngày hoặc tạo bản ghi vận chuyển mới',
  'you.could.save': 'Bạn có thể tiết kiệm bằng cách đi tuyến đường tối ưu',
};
